import { createFileRoute } from '@tanstack/react-router'

import { DrawerView } from '@/features/shelf/DrawerView'

interface DrawerSearch {
  /** The lot a scanned label pointed at. */
  lot?: string
  /** The code that was scanned, for the header. */
  scanned?: string
}

const text = (value: unknown) =>
  (typeof value === 'string' || typeof value === 'number') && String(value)
    ? String(value)
    : undefined

export const Route = createFileRoute('/shelf/drawer/$locationId')({
  validateSearch: (search: Record<string, unknown>): DrawerSearch => ({
    lot: text(search.lot),
    scanned: text(search.scanned),
  }),
  component: ShelfDrawer,
})

function ShelfDrawer() {
  const { locationId } = Route.useParams()
  const { lot } = Route.useSearch()
  return <DrawerView key={locationId} drawerId={locationId} lotId={lot} />
}
